import useWindowSize from "app/hooks/shared/useWindowSize";
import { default as ReactConfetti } from "react-confetti";

const NAVBAR_WIDTH = 20;
const CONFETTI_COLORS = ["#69B578", "#292747", "#FFE458"];
const SHAPE_CONFIG = {
  width: 20,
  height: 10,
};

const Confetti = () => {
  const { width, height } = useWindowSize();

  return (
    <ReactConfetti
      width={width - NAVBAR_WIDTH}
      height={height}
      recycle={false}
      colors={CONFETTI_COLORS}
      drawShape={(context) =>
        context.fillRect(
          -SHAPE_CONFIG.width / 2,
          -SHAPE_CONFIG.height / 2,
          SHAPE_CONFIG.width,
          SHAPE_CONFIG.height
        )
      }
    />
  );
};
export default Confetti;
